import service from '@/services/SICUDsic_tbl';

export default {
  namespaced: true,

  actions: {
    async create({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDsic_tbl: {
            eeDatos: [rootGetters['auth/state']],
            eesic_tbl: [values],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data.dsSICUDsic_tbl;

            if (data.eeEstados[0].Returnid === 0) {
              resolve();
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve();
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    /**
     * Petición para retirar una o más cuentas de una sala.
     *
     * Arreglo con una o más cuentas: cada elemento es un objeto con las siguientes propiedades:
     * <br>
     * sal_cod: Obligatorio, id de sala.
     * usr__cod: Obligatorio, id de usuario.
     */
    async delete({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDsic_tbl: {
            eeDatos: [rootGetters['auth/state']],
            eesic_tbl: [values],
          },
        };

        let notification;

        service
          .delete(payload)
          .then((response) => {
            const data = response.data.dsSICUDsic_tbl;

            if (data.eeEstados[0].Returnid === 0) {
              resolve();
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve();
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    update({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDsic_tbl: {
            eeDatos: [rootGetters['auth/state']],
            eesic_tbl: [values],
          },
        };

        let notification;

        service
          .put(payload)
          .then((response) => {
            const data = response.data.dsSICUDsic_tbl;

            if (data.eeEstados[0].Returnid === 0) {
              resolve();
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve();
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
